// --------------------------------------------------------
// HEALTH PROFESSIONAL PANEL - HealthProfessionalPanel
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
import React, { useCallback, useEffect, useState } from "react";
import { OutlinedUpdateButton } from "../../components/UI/buttons/Button.styled";
import ContainerWithSidebar from "../../components/UI/containerWithSidebar/ContainerWithSidebar";
import {
  GeneralContainer,
  TableData,
  Text,
} from "../../components/UI/generalLayout/Layout.styled";
import ScreenHeader from "../../components/UI/screenHeader/ScreenHeader";
import useResponsiveInfo from "../../hooks/useResponsiveInfo";
import { ReactComponent as Update } from "../../assets/imgs/updateIcon.svg";
import { ChevronLeft, ChevronRight, Search } from "@mui/icons-material";
import {
  CalendarAnchor,
  CalendarRowContainer,
  ContainerHeaderPainel,
  ContainerListPainel,
  FlexEndHeaderPainel,
} from "./HealthProssionalPainel.styled";
import CareLineDropdown from "../../components/dropdown/CareLineDropdown";
import CardPainelConsults from "../../components/cardPainelConsults/CardPainelConsults";
import * as unitActions from "../../store/actions/unit";
import { useAppDispatch } from "../..";
import { useSelector } from "react-redux";
import { CircularProgress, InputAdornment, OutlinedInput, Table } from "@mui/material";
import { SchedulingService } from "../../core/http/service/SchedulingService";
import moment from "moment";
import * as medicalRecordAction from "../../store/actions/medicalRecord";
import { Roles } from "../../enums/Roles";
import Colors from "../../constants/Colors";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import { utils } from 'react-modern-calendar-datepicker';
import { Calendar, Day } from '@hassanmojab/react-modern-calendar-datepicker';
import Popup from 'reactjs-popup';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { meses, ptBrCustomLocale } from '../../constants/Objects';
import { executeWithDelay } from "../../helpers/HelperFunctions";
import Unit from "../../models/core/unit/Unit";
import { AppointmentService } from "../../core/http/service/AppointmentService";
import OpenAppointmentsModal from "../../components/openAppointmentsModal/OpenAppointmentsModal";



// --------------------------------------------------------
// HEALTH PROFESSIONAL PANEL INTERFACE
// --------------------------------------------------------
/**
 * A component that renders a Screen.
 *
 * @param props Properties
 * @param props.route The route
 * @param props.navigation The navigator
 * @returns The component JSX.
 */

function HealthProfessionalPanel(): JSX.Element {
  // --------------------------------------------------------
  // HEALTH PROFESSIONAL PANEL PRIVATE DECLARATIONS
  // --------------------------------------------------------
  const { units, unitSelectedAppointments } = useSelector(
    (state: any) => state.unit
  );

  const { isMobile } = useResponsiveInfo();
  const [selectedUnit, setSelectedUnit] = useState<any>(
    unitSelectedAppointments ?? null
  );
  const [isCurrentAppointments, setIsCurrentAppointments] =
    useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [appointments, setAppointments] = useState<any[]>([]);
  const { userInfo, currentProfile } = useSelector((state: any) => state.login);
  const isTecEnfermagem = currentProfile === "TEE";
  const [activeUnits, setActiveUnits] = useState<any[]>([])
  const [nomeOuProfissionalSearchQuery, setNomeOuProfissionalSearchQuery] = useState('')
  const [selectedDay, setSelectedDay] = useState<any>(utils('en').getToday())
  const [showOpenAppointmentsModal, setShowOpenAppointmentsModal] = useState(false);
  const [pendingAppointments, setPendingAppointments] = useState<any[]>([]);
  const dispatch = useAppDispatch();

  const fetchPendingAppointments = useCallback(async () => {
    const rolesToWarn = ["MED", "ENF", "PSI", "NUT", Roles.MED, Roles.ENF, Roles.PSI, Roles.NUT];
    const isHealthProfessional = rolesToWarn.includes(currentProfile);

    if (isHealthProfessional) {
      const appointmentService = new AppointmentService();
      try {
        const response: any = await appointmentService.getPendingAppointments();
        const pendingData = response.data.data || [];

        if (pendingData && pendingData.length > 0) {
          setPendingAppointments(pendingData);
          setShowOpenAppointmentsModal(true);
        }
      } catch (error) {
        console.error("Erro ao buscar atendimentos pendentes:", error);
      }
    }
  }, [currentProfile]);

  useEffect(() => {
    fetchPendingAppointments();
  }, [fetchPendingAppointments]);

  useEffect(() => {
    if (!!units) {
        const unidadesAtivas: any[] = []
        units.forEach((unit: Unit) => {
            if (!unit.inativo) {
                unidadesAtivas.push({ nome: unit.nomeFantasia, id: unit.id })
            }
        })
        setActiveUnits(unidadesAtivas)
    }
}, [units])

  useEffect(() => {
    
    if (selectedUnit) {
      if (nomeOuProfissionalSearchQuery.length >= 3 || nomeOuProfissionalSearchQuery === '') {
        const formattedDate = `${selectedDay.year}-${selectedDay.month}-${selectedDay.day}`
          executeWithDelay(500, async () => {
            fetchConsultas(formattedDate, nomeOuProfissionalSearchQuery);              
          })
      }
    }

}, [nomeOuProfissionalSearchQuery, selectedDay, selectedUnit, dispatch])

  const fetchUnits = useCallback(async () => {
    await dispatch(unitActions.fetchUnitList());
  }, [dispatch]);

  const updateSelectedUnit = useCallback(async () => {
    await dispatch(unitActions.updateSelectedUnitPainelConsultas(selectedUnit));
  }, [dispatch, selectedUnit]);


  const fetchConsultas = useCallback(
    async (data: string, nomeSearch: string = "") => {

      try {

        var formattedDate = `${selectedDay.year}-${selectedDay.month}-${selectedDay.day}`;
        var profissional = nomeOuProfissionalSearchQuery;

        var dataFiltro = data ? data : formattedDate? formattedDate : null;
        var profissonalFiltro = nomeSearch && nomeSearch.length >= 3  ? nomeSearch : profissional && profissional.length >= 3? profissional : null;

        const service: SchedulingService<any> = new SchedulingService();
        setIsLoading(true);
        const consultas: any[] = [];
        const params = {
          ProfissionalId: isTecEnfermagem ? "" : userInfo.id,
          UnidadeAtendimentoId: selectedUnit?.id,
          DataInicio: dataFiltro,
          DataFim: dataFiltro,
          PageSize: 1000,
          nome: profissonalFiltro,
        };
        const result: any = await service.getInfoPainelConsultas(params);
        result.data.data.forEach((d: any) => {
          consultas.push(d);
        });
  
        setAppointments(consultas);
        setIsLoading(false);

      } catch (error) {
        setIsLoading(false);
      }
      
    },
    [selectedUnit, userInfo]
  );

  const getConsultas = () => {
    if (selectedUnit) {
      if (nomeOuProfissionalSearchQuery.length >= 3 || nomeOuProfissionalSearchQuery === '') {
        const formattedDate = `${selectedDay.year}-${selectedDay.month}-${selectedDay.day}`
          executeWithDelay(500, async () => {
            fetchConsultas(formattedDate, nomeOuProfissionalSearchQuery);              
          })
      }
    }
  };

  const getMaximumDate = () => {
    const day = utils('en').getToday();
    const momentDate = moment(`${day.year}-${day.month}-${day.day}`, 'YYYY-MM-DD').add(0, 'days')
    const maxDate: Day = { year: momentDate.year(), month: momentDate.month() + 1, day: Number(momentDate.format('D')) };
    return maxDate;
  }

  const getMinDate = () => {
      const day = utils('en').getToday();
      const momentDate = moment(`${day.year}-${day.month}-${day.day}`, 'YYYY-MM-DD').subtract(60, 'days')
      const minDate: Day = { year: momentDate.year(), month: momentDate.month() + 1, day: Number(momentDate.format('D')) };
      return minDate;
  }

  const formatSelectedDay = () => {
    return `${selectedDay.day} de ${meses[selectedDay.month - 1]} de ${selectedDay.year}`
  }

  const PopupCalendar = () => {
  const maxDate = getMaximumDate()
  const minDate = getMinDate()

  return (    
      <Popup
          position="bottom center"
          nested
          trigger={
              <CalendarAnchor isMobile={isMobile}  style={{marginLeft: 0}}              
              >
                  {formatSelectedDay()}
                  <KeyboardArrowDownIcon />
              </CalendarAnchor>}            
      >
          <Calendar
              value={selectedDay}
              onChange={setSelectedDay}
              locale={ptBrCustomLocale}
              maximumDate={maxDate}
              minimumDate={minDate}
              colorPrimary={Colors.SPM600}
              colorPrimaryLight={Colors.SPM50}
              shouldHighlightWeekends
          />
      </Popup>)
  }  
  
  useEffect(() => {
    fetchUnits();
  }, [fetchUnits]);

  useEffect(() => {
    updateSelectedUnit();
    getConsultas();
  }, [selectedUnit]);

  const fetchNextAgendaDate = useCallback(async () => {
    const service: SchedulingService<any> = new SchedulingService();
    const result: any = await service.getNextSchedule(
      userInfo.id,
      selectedUnit.id
    );
    const nextDate = result.data.data !== null ? result.data.data.data : null;
    if (nextDate === null) {
      setAppointments([]);
    } else {
      const [year, month, day] = nextDate.split('-');
      const dayNumber = parseInt(day, 10);
      const monthNumber = parseInt(month, 10);

      selectedDay.day = dayNumber;
      selectedDay.month = monthNumber;
      setSelectedDay(selectedDay);        
      fetchConsultas(nextDate);
    }
  }, [userInfo, selectedUnit]);

  useEffect(() => {
    if (!isCurrentAppointments) {
      if (selectedUnit !== null) {
        if (isTecEnfermagem) {

          const tomorrow = moment.utc().add(1, "days");                        
          selectedDay.day = tomorrow.date();
          setSelectedDay(selectedDay);          
          fetchConsultas(tomorrow.format("YYYY-MM-DD"));
        } else {
          fetchNextAgendaDate();
        }
      }
    } else {
      const today = moment.utc();                      
      selectedDay.day = today.date();
      setSelectedDay(selectedDay);        
      getConsultas();
    }
  }, [isCurrentAppointments]);

  const Agenda = ({ marginTop }: any) => {
    return (
      <div
        style={{ flexDirection: "row", display: "flex", marginTop: marginTop }}
      >
        <ChevronLeft
          style={{
            marginTop: 15,
            cursor: "pointer",
            opacity: !isCurrentAppointments ? 1 : "0.5",
          }}
          onClick={
            !isCurrentAppointments
              ? () => {
                  setIsCurrentAppointments(true);
                }
              : () => {}
          }
        />
        <Text bold={true} color={"#07365F"}>
          {isCurrentAppointments ? "Agenda de Hoje" : "Próxima agenda"}
        </Text>
        <ChevronRight
          style={{
            marginTop: 15,
            cursor: "pointer",
            opacity: isCurrentAppointments ? 1 : "0.5",
          }}
          onClick={
            isCurrentAppointments
              ? () => {
                  setIsCurrentAppointments(false);
                }
              : () => {}
          }
        />
      </div>
    );
  };

  const UpdateButton = () => {
    return (
      <OutlinedUpdateButton
        style={{
          opacity: isCurrentAppointments ? 1 : 0.5,
          cursor: isCurrentAppointments ? "pointer" : "default",
        }}
        isMobile={isMobile}
        onClick={isCurrentAppointments ? getConsultas : () => {}}
      >
        <Update />
        Atualizar
      </OutlinedUpdateButton>
    );
  };

  useEffect(() => {
    dispatch(medicalRecordAction.handleActive(1));
  }, []);

  return (
    <ContainerWithSidebar>
      <GeneralContainer>
        <ContainerHeaderPainel>
          <FlexEndHeaderPainel>
            <ScreenHeader
              screenTitle={"Painel de Consultas"}
              rightButtonText={""}
              onRightButtonClick={() => {}}
              hasRightButton={false}
            />
                <div style={{ flexDirection: isMobile ? 'column' : 'row', display: 'flex' }}>
                    <Text style={{ marginRight: 10 }}>Unidade: </Text>
                    <CareLineDropdown
                        placeholder='Selecione a Unidade de Atendimento'
                        style={{ width: isMobile ? '100%' : 310 }}
                        value={selectedUnit}
                        onChange={setSelectedUnit}
                        items={activeUnits}
                        disabled={false}
                    />
                </div>
                <div>
                    <div style={{ flexDirection: isMobile ? 'column' : 'row', display: 'flex', marginTop: 10, width: isMobile ? "100%" : '100%' }}>             
                      <Text style={{width: 88}}>Data:</Text>
                      <CalendarRowContainer isMobile={isMobile}>
                        <PopupCalendar/>
                      </CalendarRowContainer>                      
                    </div>
                </div>                
                <div style={{ flexDirection: isMobile ? 'column' : 'row', display: 'flex', marginTop: 10 }}>
                    <OutlinedInput
                        style={{ borderRadius: "10px", width: isMobile ? "100%" : "450px", height: "55px" }}
                        id="outlined-adornment-amount"
                        startAdornment={
                            <InputAdornment position="start">
                                <Search />
                            </InputAdornment>
                        }
                        label=""
                        placeholder="Buscar por nome de paciente ou profissional"
                        value={nomeOuProfissionalSearchQuery}
                        onChange={(event: any) => {
                            setNomeOuProfissionalSearchQuery(event.target.value)
                        }}
                    />
                  </div>              

            {isMobile && (
              <>
                <Agenda marginTop={10} />
                <UpdateButton />
              </>
            )}
          </FlexEndHeaderPainel>

          {!isMobile && (
            <FlexEndHeaderPainel>
              <Agenda marginTop={40} />
              <UpdateButton />
            </FlexEndHeaderPainel>
          )}
        </ContainerHeaderPainel>
        {!isMobile && (
          <Table
            style={{
              width: "95%",
              marginLeft: "2%",
            }}
          >
            <TableData width={"14%"}  alignRight={false}>
              {/** Nome */}
              <Text bold>{"Nome"}</Text>
            </TableData>
            <TableData width={"10%"} alignRight={false}>
              {/** Nome */}
              <Text bold>{"Horário"}</Text>
            </TableData>
            <TableData width={"15%"} alignRight={false}>
              {/** Tipo */}
              <Text bold>{"Tipo"}</Text>
            </TableData>         
            <TableData width={"30%"} alignRight={false}>
              {/** Profissional */}
              <Text bold>{"Profissional"}</Text>
            </TableData>            
            <TableData width={"10%"}  alignRight={false}>
              {/** Status */}
              <Text bold>{"Status"}</Text>
            </TableData>
          </Table>
        )}
        {isLoading ? (
          <div style={{ textAlign: "center", marginTop: 40, height: 50 }}>
            <CircularProgress />
          </div>
        ) : (
          <ContainerListPainel>
            <>
              {appointments.map(p => {
                return (
                  <CardPainelConsults
                    status={"Encaixe"}
                    isTodaysAppointments={isCurrentAppointments}
                    data={p}
                    onChangeAppointmentStatus={getConsultas}
                    profissional={p.nomeProfissional}
                  />
                );
              })}
              {appointments.length === 0 && (
                <Text>Nenhum resultado encontrado.</Text>
              )}
            </>
          </ContainerListPainel>
        )}
      </GeneralContainer>
      <OpenAppointmentsModal
        visible={showOpenAppointmentsModal}
        appointments={pendingAppointments}
        onConfirm={() => setShowOpenAppointmentsModal(false)}
      />
    </ContainerWithSidebar>
  );
}

export default HealthProfessionalPanel;
